import { render, staticRenderFns } from "./UserForm.vue?vue&type=template&id=0d85821f&scoped=true&"
import script from "./UserForm.vue?vue&type=script&lang=ts&"
export * from "./UserForm.vue?vue&type=script&lang=ts&"
import style0 from "./UserForm.vue?vue&type=style&index=0&id=0d85821f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d85821f",
  null
  
)

export default component.exports